module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage"
  }, [_c('a', {
    attrs: {
      "id": "title162"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("For this is wisdom; to love, to live")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("To take what fate, or the gods, may give.")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("To ask no question, to make no prayer,")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("To kiss the lips and caress the hair.")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Speed passion’s ebb as you greet its flow")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("To have")]), _vm._v("—"), _c('em', {
    staticClass: "i"
  }, [_vm._v("to hold")]), _vm._v("—"), _c('em', {
    staticClass: "i"
  }, [_vm._v("and")]), _vm._v("—"), _c('em', {
    staticClass: "i"
  }, [_vm._v("in time")]), _vm._v("—"), _c('em', {
    staticClass: "i"
  }, [_vm._v("let go!")])])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—Laurence Hope")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d454aac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466821378_epi01.vue
// module id = 78
// module chunks = 0